module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('v-alert', {
    staticClass: "errors",
    attrs: {
      "color": "error"
    },
    model: {
      value: (_vm.errors.length),
      callback: function($$v) {
        _vm.$set(_vm.errors, "length", $$v)
      },
      expression: "errors.length"
    }
  }, _vm._l((_vm.errors), function(error, index) {
    return _c('div', {
      key: index
    }, [_vm._v(_vm._s(error))])
  })), _vm._v(" "), (_vm.isEmailValidated) ? _c('v-form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.setPassword()
      }
    }
  }, [_c('v-alert', {
    staticClass: "mb-3",
    attrs: {
      "type": "info",
      "value": true
    }
  }, [_vm._v("\n        Votre mot de passe doit contenir au moins 6 caractères\n      ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "mb-4",
    attrs: {
      "solo": "",
      "label": "Mot de passe",
      "required": "",
      "type": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "mb-4",
    attrs: {
      "solo": "",
      "label": "Confirmation de mot de passe",
      "required": "",
      "type": "password"
    },
    model: {
      value: (_vm.repeatPassword),
      callback: function($$v) {
        _vm.repeatPassword = $$v
      },
      expression: "repeatPassword"
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "type": "submit",
      "round": "",
      "large": "",
      "color": "info"
    }
  }, [_vm._v("\n          Accéder à Weview\n        ")])], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53865b4b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SetPassword.vue
// module id = 552
// module chunks = 1